module.exports = __webpack_public_path__ + "img/Flag_of_the_Comoros.d2d95906.svg";